import BallJamFlow from "./BallJamFlow";

export default function NoPowerDropBallJamFlow(): React.JSX.Element | null {
    return BallJamFlow({ noPowerDrop: true });
}
